var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { QueryClientProvider } from '@tanstack/react-query';
import { ConnectedRouter } from 'connected-react-router';
import { createHashHistory } from 'history';
import { keyBy, mapValues, noop } from 'lodash';
import { Component, Suspense } from 'react';
import { Provider } from 'react-redux';
import { Redirect, Router, Switch } from 'react-router-dom';
import { ELSModalProvider } from '@els/els-component-modal-react';
import { ELSCommonUIConstants, ELSIdleProvider, ELSLoggingService, ELSPageLoader, ELSSecurityRoutes, ELSTokenHelper, ELSTokenServiceRegistrar } from '@els/els-ui-common-react';
import { ELSAccessibilityFocusState, ELSRouterHelper, ErrorBoundary, withHTMLHeadSEO } from 'components/common';
import AdobeAnalyticsInit from 'components/common/adobe-analytics-init/AdobeAnalyticsInit';
import AppToast from 'components/common/els-toast/ELSToast';
import LanguageProvider from 'components/common/language-provider/LanguageProvider';
import LocationChangeHandler from 'components/common/location-change/LocationChangeHandler';
import MockServiceHandler from 'components/common/mock-service-handler/MockServiceHandler';
import PendoInit from 'components/common/pendo-init/PendoInit';
import SessionTimeoutWarning from 'components/common/session-management/SessionTimeoutWarning';
import { getTokenExpiresAt, refreshAndGetExpiry, TOKEN_POLL_INTERVAL_MS, WARNING_TIME } from 'components/common/session-management/SessionTimeoutWarningHelper';
import { setDefaultAppConfig } from 'config/app.config';
import { queryClient } from 'config/query-client.config';
import { AppConstant, ROLE_KEY } from 'constants/app.constant';
import { CACHE_TTL } from 'constants/cache.constant';
import { queryKeys } from 'constants/query-keys.constant';
import { checkPathMatch, checkPathMatchV2, sherEvolCourseFromEolsUsers } from 'helpers/app.helper';
import { wrapRouteWithAnalytics } from 'helpers/route.helper';
import { getCatalogs } from 'helpers/ui.helper';
import { SystemType } from 'models';
import { configureStore, handleDataRestore } from 'redux/app.store';
import { appActions } from 'redux/ducks/app';
import { filterActions } from 'redux/ducks/filter';
import { AppRoutes } from 'routes/app.routes';
import { IntegrationRoutes } from 'routes/integration.routes';
import { TimeoutRoutes } from 'routes/timeout.routes';
import { UserHomeRoutes } from 'routes/user.home.routes';
import { fetchFeatureFlags as fetchFeatureFlagsService } from 'services/feature-flag.service';
import { fetchAllEolsUserByEolsUserId } from 'services/user-management.service';
import { deleteAllOldIndexedDBRecords } from 'indexedDB/db';
import { cwRoutePrefix } from 'reports/cw/constants/cw.constant';
import { courseActions } from 'reports/cw/redux/ducks/courses';
import { CwRoutes } from 'reports/cw/routes/cw.routes';
import { fetchCourseSectionInfo } from 'reports/cw/services/courses.service';
import { fetchCWAssignmentByCourseSectionId } from 'reports/cw/services/report.service';
import { DpRoutes } from 'reports/dp/routes/dp.routes';
import { EhrRoutes } from 'reports/ehr/routes/ehr.routes';
import { fetchEAQTopicMappedHesiExam, fetchEAQTopicMappedHesiExamByISBN } from 'reports/ehr/services/api.service';
import { DEFAULT_PROGRAM_ID, HAD_PATHS } from 'reports/had/constants/had.constant';
import { hadActions } from 'reports/had/redux/ducks/had';
import { HadRoutes } from 'reports/had/routes/had.routes';
import { fetchPrograms, fetchRelatedUserInfo } from 'reports/had/services/had.service';
import { HesiNGRoutes } from 'reports/hesi-ng/routes/hesi-ng.routes';
import { RESOURCE_TYPES } from 'reports/ps/constants';
import { PsRoutes } from 'reports/ps/routes/ps.routes';
import { SH_PATHS } from 'reports/sh/constants/sh.constant';
import { ShRoutes } from 'reports/sh/routes/sh.routes';
import { SparkRoutes } from 'reports/cw/routes/spark.routes';
import '../assets/main.scss';
setDefaultAppConfig();
ELSTokenServiceRegistrar.initializeFromReload();
export var history = createHashHistory();
export var store = configureStore(history);
var redirectToUserHomepage = function (_a) {
    var user = _a.user, role = _a.role;
    var userHome = UserHomeRoutes.getUserHome();
    history.push({ state: user, pathname: userHome[role] });
};
// TODO: review some of these exported functions, determine if they're needed, and move them to a common file
export var fetchFeatureFlags = function () {
    if (ELSTokenServiceRegistrar.getToken()) {
        store.dispatch(appActions.setIsFeatureFlagsLoading(true));
        fetchFeatureFlagsService()
            .then(function (payload) {
            store.dispatch(appActions.setFeatureFlags(payload.data));
        })
            .finally(function () {
            store.dispatch(appActions.setIsFeatureFlagsLoading(false));
        });
    }
};
export var setEAQTopicMappedHesiExamByCourseId = function () { return __awaiter(void 0, void 0, void 0, function () {
    var appState, _a, courses, entitlements, isbnList, eaqTopicMappedHesiExamByISBN;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                appState = store.getState()[AppConstant.reduxResources.APP_STATE];
                _a = appState.courses, courses = _a === void 0 ? [] : _a;
                entitlements = courses.flatMap(function (c) { return c.entitlements; });
                isbnList = Array.from(new Set(entitlements.map(function (etm) { return etm.isbn; })));
                return [4 /*yield*/, queryClient.fetchQuery({
                        queryKey: queryKeys.eaqHesiCatalogByISBN(isbnList),
                        queryFn: function () { return fetchEAQTopicMappedHesiExamByISBN(isbnList); },
                        staleTime: CACHE_TTL,
                        cacheTime: CACHE_TTL
                    })];
            case 1:
                eaqTopicMappedHesiExamByISBN = _b.sent();
                store.dispatch(appActions.setEaqTopicMappedHesiExamByISBN(eaqTopicMappedHesiExamByISBN));
                return [2 /*return*/];
        }
    });
}); };
export var setEAQTopicMappedHesiExam = function (courseSection) {
    var _a;
    var isbnList = ((_a = courseSection === null || courseSection === void 0 ? void 0 : courseSection.entitlements) === null || _a === void 0 ? void 0 : _a.map(function (etm) { return etm.isbn; })) || [];
    // As in setCourseSectionInfo: only show loading when this will really hit the network, so a
    // cached catalog does not flash the bento box items into their loading state on every remount.
    var cachedCatalog = queryClient.getQueryCache().find(queryKeys.eaqHesiCatalog(isbnList));
    if (!cachedCatalog || cachedCatalog.isStaleByTime(CACHE_TTL)) {
        store.dispatch(appActions.setIsEAQTopicMappedHesiExamLoading(true));
    }
    // Shares a cache entry with EHRHome's own catalog fetch, so whichever runs first serves the other.
    return queryClient
        .fetchQuery({
        queryKey: queryKeys.eaqHesiCatalog(isbnList),
        queryFn: function () { return fetchEAQTopicMappedHesiExam(isbnList); },
        staleTime: CACHE_TTL,
        cacheTime: CACHE_TTL
    })
        .then(function (res) {
        store.dispatch(appActions.setEAQTopicMappedHesiExam(res));
    })
        .finally(function () {
        store.dispatch(appActions.setIsEAQTopicMappedHesiExamLoading(false));
    });
};
var checkCourseHasCWData = function (userId, courseSections) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        store.dispatch(appActions.setIsCWBentoBoxLinkShow(false));
        store.dispatch(appActions.setIsCWBentoBoxLinkLoading(true));
        queryClient
            .fetchQuery({
            queryKey: queryKeys.relatedUserInfo(userId),
            queryFn: function () { return fetchRelatedUserInfo(userId); },
            staleTime: CACHE_TTL,
            cacheTime: CACHE_TTL
        })
            .then(function (res) {
            var eolsUsers = res.data.map(function (x) { return x.eolsUser; });
            var courseSectionsForAllEolsUsers = eolsUsers.map(function (x) { return x.courseSections; });
            if (courseSectionsForAllEolsUsers.length) {
                var dataExists = courseSectionsForAllEolsUsers.some(function (thisUserCourseSections) { return thisUserCourseSections.length; });
                if (dataExists) {
                    store.dispatch(appActions.setIsCWBentoBoxLinkShow(true));
                }
            }
        })
            .catch(function () {
            if (courseSections && courseSections.length) {
                var hasCWCourse = courseSections.some(function (cs) { return cs.courseId; });
                if (hasCWCourse) {
                    store.dispatch(appActions.setIsCWBentoBoxLinkShow(true));
                }
            }
        })
            .finally(function () { return store.dispatch(appActions.setIsCWBentoBoxLinkLoading(false)); });
        return [2 /*return*/];
    });
}); };
// eolsUserId is passed in rather than derived from allEolsUsers: it identifies the logged-in user
// for the catalog cache key. Inferring it from the crosswalk list would be undefined whenever that
// list is empty, which would make two different users share one cache entry.
export var setCatalogAndAssignments = function (courses, allEolsUsers, courseSectionInfo, eolsUserId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, catalog, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, Promise.all([
                    queryClient.fetchQuery({
                        queryKey: queryKeys.catalog(eolsUserId, courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.id, RESOURCE_TYPES.REVIEW_QUIZ.id),
                        queryFn: function () { return getCatalogs(courses, allEolsUsers, RESOURCE_TYPES.REVIEW_QUIZ.id); },
                        staleTime: CACHE_TTL,
                        cacheTime: CACHE_TTL
                    }),
                    queryClient.fetchQuery({
                        queryKey: queryKeys.cwAssignments(courseSectionInfo === null || courseSectionInfo === void 0 ? void 0 : courseSectionInfo.id),
                        queryFn: function () { return fetchCWAssignmentByCourseSectionId(courseSectionInfo.id); },
                        staleTime: CACHE_TTL,
                        cacheTime: CACHE_TTL
                    })
                ])];
            case 1:
                _a = _b.sent(), catalog = _a[0].catalog, data = _a[1].data;
                store.dispatch(appActions.setCatalog(catalog));
                store.dispatch(appActions.setAssignments(data));
                return [2 /*return*/];
        }
    });
}); };
export var setCourses = function (loggedInUser, courseSectionInfo) { return __awaiter(void 0, void 0, void 0, function () {
    var isHADPath, userId, _a, data, courseSections, courses, checkCourseList_1, filteredCourseSections, isCWInstructorPath;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                isHADPath = checkPathMatch(Object.values(HAD_PATHS));
                userId = (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.id) || (loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.userId);
                return [4 /*yield*/, queryClient.fetchQuery({
                        queryKey: queryKeys.allEolsUsers(userId, SystemType.EVOLVETYPE),
                        queryFn: function () { return fetchAllEolsUserByEolsUserId(userId, SystemType.EVOLVETYPE); },
                        staleTime: CACHE_TTL,
                        cacheTime: CACHE_TTL
                    })];
            case 1:
                _a = (_c.sent()).data, data = _a === void 0 ? [] : _a;
                if (data === null || data === void 0 ? void 0 : data.length) {
                    store.dispatch(appActions.setAllEolsUsers(data));
                }
                courseSections = sherEvolCourseFromEolsUsers(data);
                courses = courseSections;
                if (isHADPath || !(loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.courseSections)) {
                    store.dispatch(appActions.setCourses(courseSections));
                    checkCourseHasCWData(userId, courseSections);
                }
                else {
                    checkCourseList_1 = mapValues(keyBy((loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.courseSections) || [], 'id'), 'id');
                    filteredCourseSections = courseSections.filter(function (c) { return !checkCourseList_1[c.id]; });
                    courses = (_b = loggedInUser === null || loggedInUser === void 0 ? void 0 : loggedInUser.courseSections) === null || _b === void 0 ? void 0 : _b.concat(filteredCourseSections);
                    store.dispatch(appActions.setCourses(courses));
                    checkCourseHasCWData(userId, courses);
                }
                setEAQTopicMappedHesiExamByCourseId();
                isCWInstructorPath = checkPathMatchV2(Object.values(cwRoutePrefix), false);
                if (isCWInstructorPath) {
                    setCatalogAndAssignments(courses, data, courseSectionInfo, userId);
                }
                return [2 /*return*/];
        }
    });
}); };
// Awaits (rather than fire-and-forgets) setEAQTopicMappedHesiExam/setCourses so a rejection from
// either is actually caught here - a plain try/catch around an un-awaited async call can only ever
// catch a synchronous throw, never the call's own async failure.
var runEAQCascade = function (courseSection, loggedInUser) { return __awaiter(void 0, void 0, void 0, function () {
    var isSHPath, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, setEAQTopicMappedHesiExam(courseSection)];
            case 1:
                _a.sent();
                isSHPath = checkPathMatch(Object.values(SH_PATHS));
                if (!!isSHPath) return [3 /*break*/, 3];
                return [4 /*yield*/, setCourses(loggedInUser, courseSection)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                err_1 = _a.sent();
                ELSLoggingService.error('runEAQCascade', "Error while attempting to fetch setEAQTopicMappedHesiExam, error: ".concat(err_1.message));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); };
export var setCourseSectionInfo = function (courseId_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([courseId_1], args_1, true), void 0, function (courseId, onComplete) {
        var appState_1, selectedCourseId_1, cachedCourseSection, willFetchCourseSection, cascadePromise_1;
        if (onComplete === void 0) { onComplete = noop; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!ELSTokenServiceRegistrar.getToken()) return [3 /*break*/, 3];
                    appState_1 = store.getState()[AppConstant.reduxResources.APP_STATE];
                    selectedCourseId_1 = courseId || appState_1.selectedCourse;
                    cachedCourseSection = queryClient.getQueryCache().find(queryKeys.courseSectionInfo(selectedCourseId_1));
                    willFetchCourseSection = !cachedCourseSection || cachedCourseSection.isStaleByTime(CACHE_TTL);
                    if (willFetchCourseSection) {
                        store.dispatch(courseActions.setIsCourseFetching(true));
                        store.dispatch(appActions.setIsEAQTopicMappedHesiExamLoading(true));
                    }
                    cascadePromise_1 = Promise.resolve();
                    // fetchQuery dedupes by courseId and serves from cache within CACHE_TTL, so the repeated mount
                    // effects (useInstructorHomeComponent.ts, useSHStudentDetailsHook.tsx) and the course-switch
                    // path (useCourseAggregateCard.ts, usePrescriptionForSuccessTab.ts) all share one request.
                    // Switching to a different course is a different key, so Redux still gets the right course;
                    // call queryClient.invalidateQueries(queryKeys.courseSectionInfo(id)) to force a refresh.
                    return [4 /*yield*/, queryClient
                            .fetchQuery({
                            queryKey: queryKeys.courseSectionInfo(selectedCourseId_1),
                            queryFn: function () { return fetchCourseSectionInfo(selectedCourseId_1); },
                            staleTime: CACHE_TTL,
                            cacheTime: CACHE_TTL
                        })
                            .then(function (response) {
                            var courseSection = response.data;
                            store.dispatch(courseActions.setCourseSectionInfo(courseSection));
                            // onComplete fires immediately - navigation shouldn't block on the EAQ/catalog cascade,
                            // matching prior behavior. The cascade's own promise is still awaited below (after
                            // isCourseFetching resets) purely so callers/tests can reliably wait for it to settle,
                            // without changing onComplete/isCourseFetching timing.
                            cascadePromise_1 = runEAQCascade(courseSection, appState_1.loggedInUser);
                            onComplete();
                        })
                            .catch(function (err) {
                            // Pre-existing gap, closed here: a failed course-section fetch used to escape as an
                            // unhandled rejection (no caller catches setCourseSectionInfo) and left
                            // isEAQTopicMappedHesiExamLoading stuck at true - only the cascade's own finally resets
                            // that flag, and the cascade never starts when this fetch fails. React Query does not
                            // cache the rejection, so the next call still retries.
                            ELSLoggingService.error('setCourseSectionInfo', "Error while attempting to fetch course section info, error: ".concat(err === null || err === void 0 ? void 0 : err.message));
                            store.dispatch(appActions.setIsEAQTopicMappedHesiExamLoading(false));
                        })
                            .finally(function () {
                            store.dispatch(courseActions.setIsCourseFetching(false));
                        })];
                case 1:
                    // fetchQuery dedupes by courseId and serves from cache within CACHE_TTL, so the repeated mount
                    // effects (useInstructorHomeComponent.ts, useSHStudentDetailsHook.tsx) and the course-switch
                    // path (useCourseAggregateCard.ts, usePrescriptionForSuccessTab.ts) all share one request.
                    // Switching to a different course is a different key, so Redux still gets the right course;
                    // call queryClient.invalidateQueries(queryKeys.courseSectionInfo(id)) to force a refresh.
                    _a.sent();
                    return [4 /*yield*/, cascadePromise_1];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var setHADProgram = function () {
    var isHADPath = checkPathMatch(Object.values(HAD_PATHS));
    if (isHADPath) {
        return;
    }
    store.dispatch(appActions.setIsCWLinkHADAndEHRChecking(true));
    fetchPrograms()
        .then(function (res) {
        store.dispatch(hadActions.setPrograms(res || []));
    })
        .catch(function (e) {
        ELSLoggingService.error('setHADProgram', "Error while attempting to fetch programs, error: ".concat(e.message));
    })
        .finally(function () {
        store.dispatch(appActions.setIsCWLinkHADAndEHRChecking(false));
    });
};
var resetData = function () {
    // Admin-backdoor re-init switches the logged-in user without reloading the page, so drop the
    // cached server data - otherwise the new user would read the previous one's courses.
    queryClient.clear();
    store.dispatch(appActions.setIsLaunchedFromAnotherApp(false));
    store.dispatch(appActions.setLinkId(null));
    store.dispatch(appActions.setIsBackToPreviousAppIconShown(false));
    store.dispatch(hadActions.setProgramId(DEFAULT_PROGRAM_ID));
    store.dispatch(hadActions.setPrograms([]));
    store.dispatch(filterActions.setCWEngagementAssignmentTypeDropdownId(null));
    sessionStorage.removeItem(ROLE_KEY);
};
export var initializeAppByAdminBackdoor = function (_a) {
    var eolsUser = _a.eolsUser, roleId = _a.roleId, courseId = _a.courseId, isbn = _a.isbn;
    store.dispatch(appActions.setLoggedInUser(eolsUser));
    store.dispatch(appActions.setUserRole(roleId));
    store.dispatch(appActions.setIsbn(isbn));
    store.dispatch(appActions.setSelectedCourse(courseId));
    store.dispatch(appActions.setCourses(eolsUser.courseSections));
    resetData();
    redirectToUserHomepage({ user: eolsUser, role: roleId });
    setCourseSectionInfo(courseId);
    setHADProgram();
    fetchFeatureFlags();
    store.dispatch(appActions.checkEHREnabled());
};
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        // create state data restored with default value false
        // One-shot guard: prevents duplicate history.push when both ELSIdleProvider and
        // SessionTimeoutWarning fire at the same moment. The flag resets naturally when
        // the App component is remounted on re-login.
        _this.sessionTimedOut = false;
        _this.tokenPollInterval = null;
        // Memoize routes so that wrapRouteWithAnalytics is NOT called on every render.
        // This prevents new component references from being created, which would cause
        // React to unmount/remount route components (e.g. IntegrationLoginComponent).
        _this.routes = ELSSecurityRoutes.getSecurityRoutes(initializeAppByAdminBackdoor)
            .filter(function (route) { return route.path !== "/".concat(ELSCommonUIConstants.security.States.TimedOut); })
            .concat(TimeoutRoutes.getRoutes())
            .concat(IntegrationRoutes.getRoutes())
            .concat(HesiNGRoutes.getRoutes())
            .concat(HadRoutes.getRoutes())
            .concat(ShRoutes.getRoutes())
            .concat(CwRoutes.getRoutes())
            .concat(EhrRoutes.getRoutes())
            .concat(PsRoutes.getRoutes())
            .concat(DpRoutes.getRoutes())
            .concat(SparkRoutes.getRoutes())
            .concat(AppRoutes.getRoutes())
            .map(wrapRouteWithAnalytics)
            .map(function (route) { return ELSRouterHelper.createRoute(route); });
        _this.startTokenPoll = function () {
            _this.stopTokenPoll();
            _this.tokenPollInterval = setInterval(function () {
                var expiresAt = getTokenExpiresAt();
                if (expiresAt > 0) {
                    _this.stopTokenPoll();
                    _this.setState({ expiresAt: expiresAt });
                }
            }, TOKEN_POLL_INTERVAL_MS);
        };
        _this.stopTokenPoll = function () {
            if (_this.tokenPollInterval) {
                clearInterval(_this.tokenPollInterval);
                _this.tokenPollInterval = null;
            }
        };
        _this.handleSessionTimeout = function () {
            if (_this.sessionTimedOut) {
                return;
            }
            _this.sessionTimedOut = true;
            ELSTokenHelper.removeToken();
            // history.push below is a client-side navigation, so the module-level queryClient would
            // otherwise keep this user's cached courses and student data in memory for the full CACHE_TTL
            // after their session ended.
            queryClient.clear();
            _this.setState({ expiresAt: 0 });
            history.push({ pathname: "/".concat(ELSCommonUIConstants.security.States.TimedOut) });
        };
        _this.handleExtendSession = function () {
            return refreshAndGetExpiry()
                .then(function (newExpiresAt) {
                _this.setState({ expiresAt: newExpiresAt });
            })
                .catch(function (error) {
                _this.handleSessionTimeout();
                throw error;
            });
        };
        _this.state = {
            dataRestored: false,
            expiresAt: getTokenExpiresAt()
        };
        return _this;
    }
    App.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        deleteAllOldIndexedDBRecords();
                        return [4 /*yield*/, handleDataRestore(store)
                                .then(function () {
                                var expiresAt = getTokenExpiresAt();
                                _this.setState({ dataRestored: true, expiresAt: expiresAt });
                                // If token is not yet available (login hasn't happened yet), poll for it
                                if (expiresAt === 0) {
                                    _this.startTokenPoll();
                                }
                            })
                                .catch(function () {
                                ELSLoggingService.warn('Error', 'Error while attempting to restore data');
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    App.prototype.componentWillUnmount = function () {
        this.stopTokenPoll();
    };
    App.prototype.render = function () {
        var HTMLHeadSEOComponent = withHTMLHeadSEO({})(null);
        if (!this.state.dataRestored) {
            return <ELSPageLoader />;
        }
        return (<QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <ConnectedRouter history={history}>
            <LanguageProvider>
              <ELSModalProvider>
                <>
                  <LocationChangeHandler />
                  <AppToast />
                  <ErrorBoundary>
                    <HTMLHeadSEOComponent />
                    <AdobeAnalyticsInit />
                    <PendoInit />
                    <MockServiceHandler />
                    <main>
                      <Router history={history}>
                        <Suspense fallback={<ELSPageLoader />}>
                          <Switch>
                            {this.routes}
                            <Redirect from="/" to={"/".concat(ELSCommonUIConstants.security.States.PageNotFound)}/>
                          </Switch>
                        </Suspense>
                      </Router>
                    </main>
                    <ELSAccessibilityFocusState />
                    {this.state.expiresAt > 0 && (<>
                        <ELSIdleProvider timeout={Math.max(this.state.expiresAt - Date.now(), 0)} onSessionTimeout={this.handleSessionTimeout}/>
                        <SessionTimeoutWarning expiresAt={this.state.expiresAt} warningTime={WARNING_TIME} onSessionTimeout={this.handleSessionTimeout} onExtendSession={this.handleExtendSession}/>
                      </>)}
                  </ErrorBoundary>
                </>
              </ELSModalProvider>
            </LanguageProvider>
          </ConnectedRouter>
        </Provider>
      </QueryClientProvider>);
    };
    return App;
}(Component));
export default App;
